<ppl-accordion [title]="'Checklist information'" [isOpen]="true" *authorize="[pageId, tabId, 'Checklist', 'section']">
  @if(isParticipant) {
  <ppl-participant-checklist [isEditable]="isEditable"></ppl-participant-checklist>
  } @else {
  <ppl-provider-checklist [isEditable]="isEditable"></ppl-provider-checklist>
  }
</ppl-accordion>